<app-video-kyc *ngIf="english"></app-video-kyc>
<app-video-kyc-hindi *ngIf="hindi"></app-video-kyc-hindi>